import React from 'react';

import { AutoComplete } from 'antd/es';
import Input from 'antd/es/input/Input';
import { FieldProps } from 'formik';

import { ListOption } from '@app/objects/SidebarProps';

interface CustomAutoCompleteProps {
	placeholder: string;
	field: FieldProps;
	onChange: (value: string, option: ListOption) => void;
	onBlur: () => void;
	allowClear?: boolean;
	adjustValue?: boolean;
	options?: Array<ListOption>;
	onFocus?: (e: React.FocusEvent<HTMLElement, Element>) => void;
	onSelect?: (value: string, option: ListOption) => void;
	customFilter?: (input: string, option: string) => boolean;
}

const CustomAutoComplete: React.FC<CustomAutoCompleteProps> = ({
	options,
	placeholder,
	field,
	onSelect,
	onChange,
	onBlur,
	onFocus,
	allowClear = false,
	adjustValue,
	customFilter,
}) => {
	const ref = React.useRef<any>(null);

	const setAdjustedValue = React.useCallback((item: ListOption) => {
		field.form.setFieldValue(field.field.name, item.value);
	}, [field.field.name, field.form]);

	const resetAdjustedValue = React.useCallback(() => {
		field.form.setFieldValue(field.field.name, '', false);
	}, [field.field.name, field.form]);

	const passAdjustedValue = React.useCallback(() => {
		if (options && options.length) {
			const value = field.field.value.toLowerCase();

			const possibleValues = options
				.filter((item) => String(item.label).toLowerCase().indexOf(value) !== -1)
				.sort((a, b) => String(a.label).toLowerCase().indexOf(value) - String(b.label).toLowerCase().indexOf(value));

			const result = possibleValues.filter((item) => item.value.toLowerCase() === value);

			if (result.length) {
				setAdjustedValue(result[0]);
			} else {
				resetAdjustedValue();
			}

			return;
		}

		resetAdjustedValue();
	}, [field.field.value, setAdjustedValue, resetAdjustedValue]);

	return (
		<>
			<AutoComplete
				ref={ref}
				allowClear={allowClear}
				options={options}
				placeholder={placeholder}
				// autoComplete="new-password"
				onSelect={onSelect}
				onChange={(value: string, option: any) => {
					onChange(value, option);
				}}
				onBlur={() => {
					adjustValue && passAdjustedValue();
					onBlur();
				}}
				onFocus={(e) => onFocus && onFocus(e)}
				value={field.field.value}
				classNames={{ popup: { root: 'custom-field-dropdown' } }}
				filterOption={(inputValue, option = { value: 'not selected' }) => {
					if (customFilter) {
						return customFilter(inputValue, typeof option.label === 'string' ? option.label : option.value || 'not selected');
					}

					return option.label && typeof option.label === 'string'
						? option.label.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
						: option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1;
				}}
			>
				<Input />
			</AutoComplete>
			<div className="custom-field__placeholder-top">{placeholder}</div>
		</>
	);
};

export default CustomAutoComplete;
